if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('cart-drawer-products-recommendation') || item.target.classList?.contains('complementary-products') ) {
            window.dispatchEvent(new Event("scroll"));
            BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

// Fallback delivery-message calculator: fills in [data-delivery-calc] spans whose
// inline <script> never ran because the card markup was injected via .innerHTML
// (recently-viewed-products, facets re-render, complementary product slider, etc.).
// Mirrors the per-card date math in card-product.liquid so both stay in sync.
(function () {
  function bd(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
  function two(n) { return n < 10 ? '0' + n : '' + n; }
  function cutoffLabel(minutes) { var h = Math.floor(minutes / 60), m = minutes % 60; return two(h) + ':' + two(m); }
  function isSameDay(a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
  function getHardbrassLengthMm(title) {
    if (!title) return null;
    var m = title.match(/(\d+)\s*[x×]\s*(\d+)\s*[x×]\s*(\d+)/i);
    if (!m) return null;
    return Math.max(parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10));
  }
  function computeBeforeCutoff(cutoffMinutes) {
    var now = new Date();
    var day = now.getDay();
    var isWeekend = (day === 0 || day === 6);
    return !isWeekend && (now.getHours() * 60 + now.getMinutes()) < cutoffMinutes;
  }
  function formatDeliveryPhrase(deliverDate, cutoffMinutes, beforeCutoff) {
    var now = new Date();
    var tomorrow = new Date(now.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);
    var weekday = deliverDate.toLocaleDateString('nl-NL', { weekday: 'long' });
    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    var dateStr = deliverDate.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' });
    if (isSameDay(deliverDate, tomorrow)) {
      return beforeCutoff ? ('Voor ' + cutoffLabel(cutoffMinutes) + ' besteld, morgen in huis') : 'Morgen bij u geleverd';
    }
    if (beforeCutoff) {
      return 'Voor ' + cutoffLabel(cutoffMinutes) + ' besteld, ' + weekday + ' ' + dateStr + ' in huis';
    }
    return weekday + ' ' + dateStr + ' in huis';
  }
  function formatInStockDeliveryText(cutoffMinutes) {
    var now = new Date();
    var beforeCutoff = computeBeforeCutoff(cutoffMinutes);
    var shipDate = beforeCutoff ? new Date(now.getTime()) : bd(now, 1);
    var deliverDate = bd(shipDate, 1);
    return formatDeliveryPhrase(deliverDate, cutoffMinutes, beforeCutoff);
  }
  function formatSpecialDeliveryText(cutoffMinutes) {
    var now = new Date();
    var beforeCutoff = computeBeforeCutoff(cutoffMinutes);
    var shipDate = bd(now, beforeCutoff ? 1 : 2);
    var deliverDate = bd(shipDate, 1);
    return formatDeliveryPhrase(deliverDate, cutoffMinutes, beforeCutoff);
  }
  function formatShip2bdText(cutoffMinutes) {
    var now = new Date();
    var day = now.getDay();
    var isWeekend = (day === 0 || day === 6);
    var beforeCutoff = !isWeekend && (now.getHours() * 60 + now.getMinutes()) < cutoffMinutes;
    var base = beforeCutoff ? now : bd(now, 1);
    var shipDate = bd(base, 2);
    var weekday = shipDate.toLocaleDateString('nl-NL', { weekday: 'long' });
    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    return 'Aankomende ' + weekday + ' bij u thuis geleverd';
  }
  function fillDeliveryMessages() {
    document.querySelectorAll('[data-delivery-calc]').forEach(function (el) {
      if (el.textContent && el.textContent.trim().length) return;
      var kind = el.getAttribute('data-delivery-calc');
      if (kind === 'instock') {
        el.textContent = formatInStockDeliveryText(1200);
      } else if (kind === 'special') {
        var cutoff = parseInt(el.getAttribute('data-cutoff-minutes'), 10) || 0;
        if (el.getAttribute('data-hardbrass') === 'true') {
          var lenMm = getHardbrassLengthMm(el.getAttribute('data-title'));
          if (lenMm !== null && lenMm >= 1400) { cutoff = 900; }
        }
        if (cutoff > 0) { el.textContent = formatSpecialDeliveryText(cutoff); }
      } else if (kind === 'ship2bd') {
        el.textContent = formatShip2bdText(1020);
      }
    });
  }
  fillDeliveryMessages();
  var deliveryObserver = new MutationObserver(function () { fillDeliveryMessages(); });
  deliveryObserver.observe(document.body, { childList: true, subtree: true });
})();
